import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { ManufacturerTableAction } from "stores/ManufacturerStore/ManufacturerAction";

const mapStateToProps = (state) => {
  return {
    AddVehicleModel: state.manufacturer.AddVehicleModel,
    vehicleModelList: state.manufacturer.vehicleModelList,
    VehicleManufactureEnableDisableListdata:
    state.manufacturer.VehicleManufactureEnableDisableListdata,
    SelectVehicleListdata: state.manufacturer.SelectVehicleListdata,
    isloadingModel: state.manufacturer.Model,
    vehicleModelTypeId: state.manufacturer.vehicleModelTypeId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postAddVehicleModel: ManufacturerTableAction.postAddVehicleModel,
      getVehicleModelAction: ManufacturerTableAction.getVehicleModelAction,
      VehicleManufactureEnableDisableAction:
        ManufacturerTableAction.VehicleManufactureEnableDisable,
      getSlectVehicleAction: ManufacturerTableAction.getSlectVehicle,
      UdateVehicleModelAction: ManufacturerTableAction.UdateVehicleModelAction,
      getVehicleTypeDropdown : ManufacturerTableAction.vehicleModalTypeDropdown,
      snackbarAction:commonActions.setSnackbarAction

    },
    dispatch
  );

const VehicleModelStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default VehicleModelStore;
